module.exports = __webpack_public_path__ + "img/level-unlocked.cad35474.svg";